import React, {useContext} from "react"
import { Row, Col, Table, Badge } from "reactstrap"
import { graphql } from "gatsby"
import Parser from "html-react-parser"
import Layout from "../../Layout"
import { linkBlock } from "./link-block"
import BlogSEO from "../BlogSEO"
import config from "../../../../config.json"
import "./styles.scss"
import ReactMarkdown from "react-markdown"
import gfm from "remark-gfm"
import Newsletter from "../../Newsletter"
import getPrefixedPath from "../../../utils/getPrefixedPath"
import { UserContextDispatch } from "../../../contexts/UserContext"
import { navigate } from "gatsby"

const renderers = {
  table: ({ children }) => {
    return <Table bordered>{children}</Table>
  },
}

const BlogPostLayout = (props) => {
  const { setTag } = useContext(UserContextDispatch)
  const {
    title,
    body_markdown,
    cover_image,
    description,
    social_image,
    published_at,
    edited_at,
    tags,
    user: { name, profile_image_90: authorImage },
  } = props.data.devArticles.article

  const url = typeof window !== "undefined" ? window.location.origin + window.location.pathname : null

  const Schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title,
    image: cover_image,
    author: {
      "@type": "Person",
      name: name,
    },
    publisher: {
      "@type": "Organization",
      name: config.siteTitle,
      logo: {
        "@type": "ImageObject",
        url: config.ogImageURL,
      },
    },

    datePublished: published_at,
    dateModified: edited_at,
  }

  return (
    <Layout>
        <BlogSEO
          url={url}
          title={title}
          socialImageURL={social_image}
          description={description}
          date={published_at}
          author={name}
          schemaMarkup={Schema}
        />
        <div className="w-100">
          <div>
            <img
              className="cover-image"
              src={cover_image || getPrefixedPath("/cover-image-background-placeholder.jpg")}
            />
          </div>
          <div className="post-container rounded">
            <Row>
              <Col>
                <Row className="justify-content-center">
                  <img src={authorImage} alt="Author Icon" className="rounded-circle post-author-image" />
                </Row>
                <Row className="justify-content-center">
                  <p className="post-author-name">{name}</p>
                </Row>
                <Row className="justify-content-center">
                  <h1 className="px-4 post-title">{title}</h1>
                </Row>
                <Row className="justify-content-center">
                  {tags.map((tag) => {
                    return (
                      <Badge onClick={(e)=>{ setTag(e.target.textContent); navigate('/') }} color="dark" className="mr-1" style={{cursor: "pointer"}} key={tag} value={tag}>
                        {tag}
                      </Badge>
                    )
                  })}
                </Row>
                <Row className="py-3 px-4">
                  <div className="post-content w-100 text-left text-md-justify">
                    <ReactMarkdown plugins={[gfm]} renderers={renderers}>
                      {body_markdown}
                    </ReactMarkdown>
                  </div>
                </Row>
                <Row className="justify-content-center">
                  <Newsletter />
                </Row>
              </Col>
            </Row>
          </div>
        </div>
    </Layout>
  )
}

export const BlogPost = graphql`
  query BlogPost($id: String) {
    devArticles(id: { eq: $id }) {
      article {
        id
        title
        body_html
        body_markdown
        cover_image
        description
        social_image
        published_at
        edited_at
        tags
        user {
          name
          profile_image_90
        }
      }
    }
  }
`

export default BlogPostLayout
